import { OrganizerFinishedGameDetailsCard } from "./organizerFinshedGameDetailsCard.molecule";

export default OrganizerFinishedGameDetailsCard;
